/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_TabInputs */

const en_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment Method`)
};

const fr_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode de paiement`)
};

const de_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsmethode`)
};

const it_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodo di pagamento`)
};

const ru_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Способ оплаты`)
};

const es_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Método de pago`)
};

const zh_cn2_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款方式`)
};

const ja_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払方法`)
};

const hi_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भुगतान विधि`)
};

const pt_pt2_payment_method_tab = /** @type {(inputs: Payment_Method_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Método de pagamento`)
};

/**
* | output |
* | --- |
* | "Payment Method" |
*
* @param {Payment_Method_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const payment_method_tab = /** @type {((inputs?: Payment_Method_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_payment_method_tab(inputs)
	if (locale === "de") return de_payment_method_tab(inputs)
	if (locale === "it") return it_payment_method_tab(inputs)
	if (locale === "ru") return ru_payment_method_tab(inputs)
	if (locale === "es") return es_payment_method_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_payment_method_tab(inputs)
	if (locale === "ja") return ja_payment_method_tab(inputs)
	if (locale === "hi") return hi_payment_method_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_payment_method_tab(inputs)
	return en_payment_method_tab(inputs)
});